import { Payload, useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'
import { isUndefined } from 'lodash'
import { fetchSystemLogs, fetchSystemLogStats } from '../api/installation.api'
import { parseActiveFilter } from '../installation.functions'

import { DeviceLinkModel, SystemlogModel, SystemLogStatsModel } from '../models'
import { SystemLogFilterWithoutSetter } from '../types'

interface UseSystemlogHook {
  getSystemlogs: (
    installationId: number | undefined,
    limit: number,
    offset: number,
    activeFilters: SystemLogFilterWithoutSetter,
    deviceLinks: DeviceLinkModel[]
  ) => Promise<SystemlogModel[]>
  getSystemlogStats: (
    installationId: number | undefined,
    activeFilters: SystemLogFilterWithoutSetter,
    deviceLinks: DeviceLinkModel[]
  ) => Promise<SystemLogStatsModel>
  getAllSystemlogStats: (installationId: number) => Promise<SystemLogStatsModel>
}

const useSystemlog = (): UseSystemlogHook => {
  const authFetch = useAuthFetchWithResponse()

  const getSystemlogs = async (
    installationId: number | undefined,
    limit: number,
    offset: number,
    activeFilters: SystemLogFilterWithoutSetter,
    deviceLinks: DeviceLinkModel[]
  ): Promise<SystemlogModel[]> => {
    if (isUndefined(installationId)) {
      return []
    }

    const { sort, filter } = parseActiveFilter(activeFilters, deviceLinks)
    const payload: Payload = { sort, filter, limit, offset }

    const systemlog = await fetchSystemLogs(installationId, payload, authFetch)

    return systemlog || []
  }

  const getSystemlogStats = async (
    installationId: number | undefined,
    activeFilters: SystemLogFilterWithoutSetter,
    deviceLinks: DeviceLinkModel[]
  ): Promise<SystemLogStatsModel> => {
    if (isUndefined(installationId)) {
      return { count: 0 }
    }
    const { filter } = parseActiveFilter(activeFilters, deviceLinks)
    const payload: Payload = { filter }

    const systemlogStats = await fetchSystemLogStats(installationId, payload, authFetch)

    return systemlogStats.value || { count: 0 }
  }

  const getAllSystemlogStats = async (installationId: number): Promise<SystemLogStatsModel> => {
    if (isUndefined(installationId)) {
      return { count: 0 }
    }

    const systemlogStats = await fetchSystemLogStats(installationId, {}, authFetch)

    return systemlogStats.value || { count: 0 }
  }

  return { getSystemlogs, getSystemlogStats, getAllSystemlogStats }
}

export default useSystemlog
